import { Skeleton } from '@zorro/design-system/v2/Skeleton';

const TEXT_HEIGHT = 20;
const CARD_HEIGHT = 260;

export const PaymentDetailsSkeleton = () => (
  <>
    <Skeleton height={TEXT_HEIGHT} w="200" />
    <Skeleton height={CARD_HEIGHT} w="400" radius={12} />
  </>
);
